import { jsx as _jsx } from "react/jsx-runtime";
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { retryImportInsideRoutesDefinition } from 'utils/lazyWithRetry';
export const projectRoutes = {
    path: ROUTE_PATHS.PROJECTS,
    children: [
        {
            path: ROUTE_PATHS.PROJECT_CREATE,
            caseSensitive: true,
            async lazy () {
                const { CreatePageRenderer } = await retryImportInsideRoutesDefinition(()=>import('./create-page-renderer'));
                return {
                    element: /*#__PURE__*/ _jsx(CreatePageRenderer, {})
                };
            }
        },
        {
            path: `${ROUTE_PATHS.EMPTY}`,
            caseSensitive: true,
            async lazy () {
                const { ProjectListV2Page } = await retryImportInsideRoutesDefinition(()=>import('./list-v2'));
                return {
                    element: /*#__PURE__*/ _jsx(ProjectListV2Page, {})
                };
            }
        },
        {
            path: `${ROUTE_PATHS.PROJECT_ID}/${ROUTE_PATHS.MATCH_ALL}`,
            async lazy () {
                const { ProjectDetailRoute } = await retryImportInsideRoutesDefinition(()=>import('./detail'));
                return {
                    element: /*#__PURE__*/ _jsx(SecureRoute, {
                        children: /*#__PURE__*/ _jsx(ProjectDetailRoute, {})
                    })
                };
            }
        }
    ]
};
